import { useEffect, useState } from 'preact/hooks';

/** The engine price as the server prices it for this visitor (EUR, or USD in the US). Cached; default before the fetch. */
const KEY = 'roardrive:price:v1';
const DEFAULT = '4,99 €';   // what the server prices at (CAR_PRICE_CENTS=499); shown until /api/price answers
let cached: string | null = null;
let inflight: Promise<string> | null = null;

/** Best guess of the visitor's country when the edge does not tell the server (US → USD). Harmless if wrong: same 4.99. */
export function guessCountry(): string {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    const lang = (navigator.language || '').toLowerCase();
    const usTz = /^America\/(New_York|Chicago|Denver|Los_Angeles|Phoenix|Anchorage|Detroit|Boise|Indiana|Kentucky|North_Dakota|Juneau|Nome|Sitka|Yakutat|Adak)|^Pacific\/Honolulu|^US\//.test(tz);
    // WHERE THE PHONE IS, not what language it speaks. Marc's iPhone is in English and sits in Barcelona,
    // and the language test alone billed him in dollars (his own checkout screenshot said US$4.99). The
    // clock knows the country; the language only gets a say when there is no clock to ask.
    if (usTz) return 'US';
    if (!tz && lang === 'en-us') return 'US';
  } catch { /* ignore */ }
  return '';
}

export function getPriceLabel(): string {
  if (cached) return cached;
  try { const v = localStorage.getItem(KEY); if (v) { cached = v; return v; } } catch { /* ignore */ }
  return DEFAULT;
}

export function loadPrice(): Promise<string> {
  if (inflight) return inflight;
  inflight = fetch(`/api/price?cc=${encodeURIComponent(guessCountry())}`).then(async (r) => {
    if (!r.ok) return getPriceLabel();
    const j = (await r.json()) as { label?: string };
    if (j.label) { cached = j.label; try { localStorage.setItem(KEY, j.label); } catch { /* ignore */ } }
    return getPriceLabel();
  }).catch(() => getPriceLabel());
  return inflight;
}

export function usePrice(): string {
  const [label, setLabel] = useState(getPriceLabel());
  useEffect(() => { void loadPrice().then(setLabel); }, []);
  return label;
}
